<template>
  <div class="adminUsers" v-if="transTest">
    <v-container>
      <v-card class="ma-10">
        <v-card-title class="font-weight-light display-2 text-uppercase">
          {{ transTest.userAdmin.title[userLang] }}
        </v-card-title>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="search"
              label="Search ..."
              class="mx-4"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col class="pt-6"> </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="users"
          class="elevation-1"
          :items-per-page="10"
          :search="search"
          :custom-filter="customSearch"
          multi-sort
          id="users"
          item-key="ID"
          :expanded.sync="expanded"
          :single-expand="singleExpand"
        >
          <!--     <template v-slot:header.user_name="{ header }">
      <span> {{ header.text.toUpperCase() }} </span>
    </template>

 -->
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <!-- all the content -->
              <td v-for="(header, key) in headers" :key="key">
                <v-text-field
                  v-if="header.type === 'text'"
                  v-model="item[header.value]"
                  label="Edit"
                  @change="save(item)"
                  single-line
                  rounded
                  background-color="teal lighten-4"
                >
                </v-text-field>

                <v-autocomplete
                  v-else-if="header.type === 'select'"
                  v-model="item[header.value]"
                  @input="save(item)"
                  :items="header.options"
                  rounded
                  background-color="teal lighten-4"
                >
                  {{ item[header.value] }}
                </v-autocomplete>
                <v-simple-checkbox
                  v-else-if="header.type === 'check'"
                  v-model="item[header.value]"
                  @change="save(item)"
                  :ripple="false"
                >
                  {{ item[header.value] }}
                </v-simple-checkbox>
                <v-btn
                  v-else-if="header.type === 'drop'"
                  @click="expand(!isExpanded)"
                >
                  <v-icon v-if="!isExpanded">fa-ellipsis-h</v-icon>
                  <v-icon v-else-if="isExpanded" class="">fa-ellipsis-v</v-icon>
                </v-btn>
                <!-- expansion button -->
              </td>
            </tr>
          </template>
          <!-- block for expansion -->
          <template v-slot:expanded-item="{ headers, item }">
            <td v-for="(header, key) in expansionHeaders" :key="key">
              <v-card color="grey lighten-4" outlined class="">
                <v-row>
                  <v-col cols="" class="mt-1 ml-4">
                    <span class=""> {{ header.text }} </span>:
                  </v-col>
                </v-row>
                <v-row class="">
                  <v-col class="mx-2" my-0>
                    <v-text-field
                      v-if="header.type === 'text'"
                      v-model="item[header.value]"
                      label="Edit"
                      @change="save(item)"
                      single-line
                      rounded
                      background-color="teal lighten-4"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-divider />
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div>
        <v-snackbar type="success" :value="alert" transition="fade-transition">
          User updated successfully
        </v-snackbar>
      </div>
    </v-container>
  </div>
</template>

<style>
#users table thead {
  background: #e57373;
  font-size: 50px !important;
}
table.v-table thead th {
  font-size: 40px !important;

  .v-select {
    padding-left: 3px;
    background: green;
  }
}
</style>

<script>
export default {
  methods: {
    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    fetchTranslations: function () {
      this.$api
        .get(this.$store.state.pathDepth + "lang/admin.json")
        .then((response) => {
          //   // console.log(response);
          this.transTest = response.data;
        });
    },
    customSearch(value, search, item) {
      return Object.values(item).some(
        (v) => v && v.toString().toLowerCase().includes(search.toLowerCase())
      );
    },

    fetchClean: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.$api
            .post(
              this.$store.state.pathDepth + "user_query.php",
              response.data["ID"]
            )
            .then((response) => {
              this.users = response.data;
            });
        });
    },
    fetchOrgs: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          this.$api
            .post(this.$store.state.pathDepth + "org_query.php", this.session)
            .then((response) => {
              this.orgs = response.data;
            });
        });
    },

    save(user) {
      var vm = this;

      // make sure sure we update the right org_id
      this.orgs.filter((obj) => {
        if (obj.org_name === user.org_name) {
          user.org_ID = obj.ID;
        }
      });

      this.$api
        .post(this.$store.state.pathDepth + "useradmin_update.php", {
          info: user,
          session: vm.session,
        })
        .then((response) => {
          setTimeout(function () {
            console.log(response.data);
          }, 500);
          vm.alert = true;
          setTimeout(function () {
            vm.alert = false;
          }, 2000);
        });
    },
    cancel() {},
    open() {},
    close() {},
  },
  created: function () {
    // this.fetchAll();
    this.userLang = this.getCookie("recup_lang");
    this.fetchTranslations();

    this.fetchClean();
    this.fetchOrgs();

    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
  },
  watch: {
    orgs: function () {
      // use a watch function for orgs because of ajax delay
      // for the header for organization, assign all names to the select options
      this.headers.filter((obj) => {
        if (obj.text === "Organization") {
          obj.options = this.orgs.map(({ org_name }) => org_name);
        }
      });
    },
  },
  computed: {
    // headers: function () {
    //   // if (this.transTest) {
    //   //   headers.forEach(
    //   //     (o, i, h) =>
    //   //       // if(h[i][value]!= "") {
    //   //       (
    //   //         h[i]["text"] = this.transTest[h[i]["value"]]
    //   //         )
    //   //     // }
    //   //   );
    //   // }
    //   return headers;
    // },
  },

  data() {
    return {
      search: "",
      alert: false,
      expanded: [],
      singleExpand: true,
      transTest: null,
      userLang: "EN",
      headers: [
        {
          text: "Username",
          value: "user_name",
          type: "text",
        },
        {
          text: "Organization",
          value: "org_name",
          type: "select",
          options: ["user", "admin"],
        },
        {
          text: "E-mail",
          value: "user_email",
          type: "text",
        },
        {
          text: "Permission",
          value: "permission",
          type: "select",
          width: "150px",
          options: ["user", "admin"],
        },
        {
          text: "Newsletter",
          value: "newsletter",
          type: "select",
          width: "150px",
          options: ["1", "0"],
        },

        {
          text: "Status",
          value: "status",
          type: "select",
          width: "150px",
          options: ["active", "pending", "inactive"],
        },
        {
          text: "",
          value: "drop",
          type: "drop",
          width: "",
        },
      ],
      expansionHeaders: [
        {
          text: "First Name",
          value: "first_name",
          type: "text",
        },
        {
          text: "Last Name",
          value: "last_name",
          type: "text",
        },
        {
          text: "Phone",
          value: "phone",
          type: "text",
        },
      ],
      users: [],
      orgs: [],
    };
  },
};
</script>
